import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import type { RootState } from "../app/store";
import { getDefaultAuthenticatedPath } from "../features/auth/defaultAuthenticatedPath";

export function PostLoginRedirect() {
	const user = useSelector((state: RootState) => state.auth.user);
	return <Navigate to={getDefaultAuthenticatedPath(user)} replace />;
}
